import { useDerivedSavingsAutocalculateFields } from '~/features/projectWizard/derived/useDerivedSavingsAutocalculateFields';
import { WorksheetField } from '../common/components/Field';
import { InputType } from '~/schema';
import { UnitDecimals, CreditRatingOptions } from '~/constants';

export default function PricingEstimateYearOneSavings() {

  // Update avoided cost of solar / year one savings when either of the fields change
  useDerivedSavingsAutocalculateFields();

  return (
    <div>
      <h3>
        Customer Savings
      </h3>
      <p style={{ marginTop: 'var(--x-small)' }}>
        Please provide either the avoided cost of power ($/kWh) or the total year 1 savings ($) on the customer’s electric bill from avoided energy costs. Providing one value will automatically calculate the other, assuming you’ve provided system production data.
      </p>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: 'var(--small)' }}>
        <div className="savings-field">
          <WorksheetField
            type="number"
            fieldLabel="Avoided cost of power ($/kWh)"
            schemaKey="avoidedCostOfSolar"
            numberType={InputType.DOLLARS}
            decimals={UnitDecimals.KWH}
          />
        </div>
        <strong style={{ margin: '1rem 1rem 0' }}>
          or
        </strong>
        <div className="savings-field">
          <WorksheetField
            type="number"
            fieldLabel="Year 1 savings ($)"
            schemaKey="yearOneSavings"
            numberType={InputType.DOLLARS}
            decimals={UnitDecimals.DOLLARS}
          />
        </div>
      </div>
      <div style={{ marginTop: '12px' }}>
        <WorksheetField
          schemaKey="customerCreditRating"
          placeholder="Select credit rating"
          fieldLabel="Customer credit rating"
          helpText="Ratings are considered investment grade if they're rated at or above BBB- (S&P or Fitch), Baa3 (Moody's).  If you don't know, please make your best estimate."
          options={CreditRatingOptions}
        />
      </div>
    </div >
  );
};